import React from "react"
import Icons from "@src/components/Icons"
import Badge from "@mui/material/Badge"

const BadgeIcon = ({ iconName, badgeNumber, onClick }) => {
  if (badgeNumber === 0) {
    return <Icons name={iconName} type="button" onClick={onClick} />
  }

  const badgeContent = badgeNumber > 99 ? "99+" : badgeNumber

  return (
    <Badge
      badgeContent={badgeContent}
      color="success"
      sx={{
        "& .MuiBadge-badge": {
          right: 2,
          top: 2,
          fontSize: badgeNumber > 99 ? 8 : 10,
          fontWeight: 600,
          width: 20,
          height: 20,
          borderRadius: "50%",
          backgroundColor: "red",
          padding: 0
        }
      }}
    >
      <Icons
        type="button"
        sx={{
          "& svg": {
            color: "#434343"
          }
        }}
        name={iconName}
        onClick={onClick}
      />
    </Badge>
  )
}

export default BadgeIcon
